import { WebphoneConnectionStatus } from '@modules/SoftPhoneModule/types';
import type { RtcsConnectionPhase } from '@modules/ServiceModule/workspace/lib/rtcsConnectionStatus';
import { strings } from '../strings';

export function hasWebphoneConnectionError(
  connectionStatus: WebphoneConnectionStatus,
): boolean {
  return (
    connectionStatus === WebphoneConnectionStatus.RegistrationFailed ||
    connectionStatus === WebphoneConnectionStatus.WebphoneJwtFetchFailed ||
    connectionStatus === WebphoneConnectionStatus.WebphoneJwtNotAvailable
  );
}

/** Never claim the agent can take calls unless the webphone is actually connected. */
export function isWebphoneCallsDown(phoneConnected: boolean): boolean {
  return !phoneConnected;
}

export function getRtcsAnnouncementCopy(
  phase: RtcsConnectionPhase,
  callsDown: boolean,
): { title: string; status: 'warning' | 'danger' } {
  if (phase === 'reconnecting') {
    return {
      status: 'warning',
      title: callsDown
        ? strings.rtcsReconnectingCallsDown
        : strings.rtcsReconnectingCallsWork,
    };
  }
  return {
    status: 'danger',
    title: callsDown ? strings.rtcsLostCallsDown : strings.rtcsLostCallsWork,
  };
}
